// extracted by mini-css-extract-plugin
module.exports = {"card":"CategoryBrands-module__card___1Rn1B","table":"CategoryBrands-module__table___1D0hn"};